import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorService } from 'app/services';

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error) {
    if (error.message === 'Bounds are not valid.' || error.message === 'latLng2 is undefined') {
      const router = this.injector.get(Router);
      const errorService = this.injector.get(ErrorService);
      if (router.url.includes('/linear/new')) {
        errorService.linearInsertComponent.errorFindingRoute();
      } else if (router.url.includes('/point/new')) {
        errorService.pointInsertComponent.errorFindingRoute();
      } else if (router.url.includes('/linear/detail')) {
        errorService.linearDetailsComponent.errorFindingRoute();
      } else if (router.url.includes('/point/detail')) {
        errorService.pointDetailsComponent.errorFindingRoute();
      } else {
        console.log('Error: ', error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/errors-handler.ts